import * as React from "react";
import { Query } from "react-apollo";
import gql from "graphql-tag";

/** GraphQL */
import { getUser } from "../../graphql/queries";

import { GetUserQuery, GetUserQueryVariables } from "../../API";

/**  Presentation UI */
import PageLoaderWrapper from "../../Components/Layouts/PageLoaderWrapper";
import PageLoader from "../../Components/PageLoader";

/** Local components */
import HeaderWrapper from "./HeaderWrapper";

/** Utils */
import { getUserId } from "../../Utils/Helpers";

/** Get logged in user id */
const userId = getUserId();

class Header extends React.Component<{}> {
  render() {
    return (
      <Query<GetUserQuery, GetUserQueryVariables>
        query={gql(getUser)}
        variables={{ id: userId }}
        fetchPolicy="cache-first"
      >
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <PageLoaderWrapper height="70px">
                <PageLoader height="70px" />
              </PageLoaderWrapper>
            );
          }
          if (error) {
            return <div>There was a problem loading your user data</div>;
          }

          if (!data) {
            return <div>There was a problem loading your user data</div>;
          }

          const user = data.getUser;

          if (!user) {
            return <div>There was a problem loading your user data</div>;
          }
          return <HeaderWrapper user={user} />;
        }}
      </Query>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/index.tsx